<mat-dialog-title>
    <h2 style="font-weight: bold;">{{ 'REQUEST_CONFIRMATION_TITLE' | translate }} 
        <span style="float:right; cursor:pointer;" class="fa-solid fa-print" (click)="print()"></span>
    </h2>
</mat-dialog-title>

<mat-dialog-content>
    <p>{{ 'REQUEST_CONFIRMATION_TITLE2' | translate }}</p>
    <div style="margin: 10px;" id="printConfirmationSectionId">
        <table id="dataTable">
            <tbody></tbody>
        </table>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" style="margin: 0px 20px 20px 20px;">
    <button mat-button class="btn-cancel" (click)="closeModal()">{{ 'COMMON_BTN_CANCEL' | translate }}</button>
    <button mat-button class="btn-save" (click)="save()">{{ 'COMMON_BTN_ACCEPT' | translate }}</button>
</mat-dialog-actions>